import React from 'react'
import { hasHighnoteTransfer } from 'api/payments/getUserPayments'
import { ExpandablePaginatedTable } from 'components/Table/ExpandablePaginatedTable'
import { useUserPaymentsContextValue } from '../context/UserPaymentsProvider'
import { useSelectedColumns } from './ColumnsFilter'
import { UserPaymentExpandedContent } from './UserPaymentsRenderers/UserPaymentExpandedContent'

export const UserPaymentsTable = () => {
  const {
    state: { data, pagination, isFetching },
    actions: { setPagination },
  } = useUserPaymentsContextValue()

  const columns = useSelectedColumns()

  return (
    <ExpandablePaginatedTable
      columns={columns}
      items={data.items}
      rowCount={data.totalRows}
      pagination={pagination}
      setPagination={setPagination}
      isFetching={isFetching}
      emptyMessage="No payments matched your search. Try using different filters."
      emptyStateMaxWidth={['100%', '100%', '50%', '50%']}
      getRowCanExpand={hasHighnoteTransfer}
      renderExpandedContent={(payment) => (
        <UserPaymentExpandedContent payment={payment} />
      )}
    />
  )
}
